import { render } from "./socialMediaIcons.vue?vue&type=template&id=16173cd1"
import script from "./socialMediaIcons.vue?vue&type=script&lang=js"
export * from "./socialMediaIcons.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BeeNeeGit\\CompStoreFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__